<template>
  <div class="about">
    <!-- <v-card color="blue lighten-5">
      <v-card-text>
        <h3>Reminder</h3>
        The materials on Life RTL are strictly not to be copied, redistributed or shared by any means.
      </v-card-text>
    </v-card>
    <p></p> -->
    <h1>{{ categoryData.Name }}</h1>
    <v-container fill-height fluid v-if="showList">
      <v-row align="center" justify="center">
        <v-text-field v-model="search" label="Type here to search..."></v-text-field>
        <v-btn elevation="2" class="mx-3 mb-2 mt-n2" small rounded v-on:click="changeDirection()">
          <v-icon class="mr-2">{{ direction[0] }}</v-icon>sort order
        </v-btn>
      </v-row>
    </v-container>
    <v-layout justify-center>
      <v-flex xs12 sm12>
        <v-card>
          <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 v-if="showThumbnail">
                <v-card>
                  <v-layout justify-center>
                    <v-img :src="categoryData.ThumbnailURL" :max-height="windowHeight" :max-width="windowWidth" contain></v-img>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex>
                <v-card v-if="showActiveCard">
                  <v-card-title>
                    <div>
                      <span>{{ eventData.Name }}</span>
                      <span v-if="eventData.ScriptureReference"> ({{ eventData.ScriptureReference }})</span>
                      <br />
                      <span class="grey--text" v-if="eventData.Author.ID">{{ eventData.Author.Name }}</span>
                      <br v-if="eventData.Author.ID" />
                      <span class="grey--text" v-if="eventData.Date">{{ eventData.Date }}</span>
                      <br v-if="eventData.Date" />
                    </div>
                  </v-card-title>
                  <vuetify-audio v-if="activeCard.ready" :file="activeCard.Url" :downloadable="activeCard.Downloadable" :mediaentryID="activeCard.ID"></vuetify-audio>
                  <video-player v-if="activeCardVideo.ready" class="vjs-custom-skin pa-2" :options="playerOption" :playsinline="true"></video-player>
                  <v-layout justify-center v-if="activeCardPhoto.ready">
                    <v-img :src="activeCardPhoto.Url" :max-height="windowHeight" :max-width="windowWidth" contain></v-img>
                  </v-layout>
                  <v-flex v-for="activeCardHandout in activeCardHandoutList" :key="activeCardHandout.ID">
                    <v-list-item v-if="activeCardHandout.Downloadable" v-on:click="downloadFile(activeCardHandout.Url, activeCardHandout.ID)">
                      <v-list-item-content>
                        <v-list-item-title class="subtitle-2 blue--text text--darken-3">Download {{ activeCardHandout.Title }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-carousel v-if="!activeCardHandout.Downloadable" :show-arrows="false" :hide-delimiters="true" :height="windowHeight" class="carousel">
                      <VuetifyPdf :url="activeCardHandout.Url" />
                    </v-carousel>
                  </v-flex>
                </v-card>
                <v-flex v-if="showList">
                  <v-list-item v-for="event in filteredItems" :key="event.ID" v-on:click="loadEvent(event.ID)">
                    <v-list-item-content>
                      <v-list-item-title>
                        <span>{{ event.Name }}</span>
                        <span v-if="event.ScriptureReference"> ({{ event.ScriptureReference }})</span>
                        <span v-if="event.Date" class="grey--text"> - {{ event.Date }}</span>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <span v-if="event.Author.Name">{{ event.Author.Name }}</span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-videojs7";
import VuetifyAudio from "../../components/VuetifyAudio";
import VuetifyPdf from "vuetify-pdfjs/src/App.vue";
import axios from "axios";

export default {
  props: {
    id: {
      type: String,
      default: "1",
    },
    customBehaviour: {
      type: String,
      default: "0",
    },
  },
  name: "EventMessageList",
  components: {
    "vuetify-audio": VuetifyAudio,
    "video-player": videoPlayer,
    VuetifyPdf,
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    windowWidth: function () {
      return 0.75 * window.innerWidth;
    },
    windowHeight: function () {
      return 0.75 * window.innerHeight;
    },
    filteredItems() {
      this.showActiveCard = false;
      return this.EventList.filter((item) => {
        this.search = this.search.toLowerCase();
        return (
          item.Name.toLowerCase().match(this.search) ||
          item.Author.Name.toLowerCase().match(this.search) ||
          item.ScriptureReference.toLowerCase().match(this.search) ||
          item.Date.toLowerCase().match(this.search)
        );
      });
    },
  },
  watch: {
    id: function (newID, oldID) {
      this.search = "";
      this.showThumbnail = false;
      this.direction = ["arrow_downward", "arrow_upward"];
      this.initialize();
    },
  },
  data() {
    return {
      search: "",
      direction: ["arrow_downward", "arrow_upward"],
      categoryData: {
        ID: 0,
        CreatedAt: "2019-06-15T02:18:04.600131+08:00",
        EditedAt: "2019-06-15T02:18:04.600131+08:00",
        DeletedAt: "",
        Name: "",
        EventGroupID: 0,
        EventGroup: {},
        ThumbnailURL: "",
      },
      eventData: {
        ID: 0,
        CreatedAt: "2019-06-15T02:18:04.600131+08:00",
        EditedAt: "2019-06-15T02:18:04.600131+08:00",
        DeletedAt: "",
        Name: "",
        Date: "",
        Category: {},
        CategoryID: {},
        Author: {},
        AuthorID: 0,
        ScriptureReference: "",
        Details: "",
      },
      showActiveCard: false,
      activeCard: {
        ID: 0,
        CreatedAt: "2019-06-15T02:18:04.600131+08:00",
        EditedAt: "2019-06-15T02:18:04.600131+08:00",
        DeletedAt: "",
        Title: "",
        ThumbnailUrl: "",
        Url: "",
        DownloadUrl: "",
        Downloadable: true,
        OriginalFilename: "",
        EncryptedFilename: "",
        Date: "",
        EventID: 0,
        Event: {},
        BucketID: 0,
        Bucket: {},
        MediaType: {},
        MediaTypeID: 0,
        Author: {},
        AuthorID: 0,
        Index: 0,
        ready: false,
      },
      activeCardPhoto: {
        ID: 0,
        CreatedAt: "2019-06-15T02:18:04.600131+08:00",
        EditedAt: "2019-06-15T02:18:04.600131+08:00",
        DeletedAt: "",
        Title: "",
        ThumbnailUrl: "",
        Url: "",
        DownloadUrl: "",
        Downloadable: true,
        OriginalFilename: "",
        EncryptedFilename: "",
        Date: "",
        EventID: 0,
        Event: {},
        BucketID: 0,
        Bucket: {},
        MediaType: {},
        MediaTypeID: 0,
        Author: {},
        AuthorID: 0,
        Index: 0,
        ready: false,
      },
      activeCardVideo: {
        ID: 0,
        CreatedAt: "2019-06-15T02:18:04.600131+08:00",
        EditedAt: "2019-06-15T02:18:04.600131+08:00",
        DeletedAt: "",
        Title: "",
        ThumbnailUrl: "",
        Url: "",
        DownloadUrl: "",
        Downloadable: true,
        OriginalFilename: "",
        EncryptedFilename: "",
        Date: "",
        EventID: 0,
        Event: {},
        BucketID: 0,
        Bucket: {},
        MediaType: {},
        MediaTypeID: 0,
        Author: {},
        AuthorID: 0,
        Index: 0,
        ready: false,
      },
      activeCardHandout: {
        ID: 0,
        CreatedAt: "2019-06-15T02:18:04.600131+08:00",
        EditedAt: "2019-06-15T02:18:04.600131+08:00",
        DeletedAt: "",
        Title: "",
        ThumbnailUrl: "",
        Url: "",
        DownloadUrl: "",
        Downloadable: true,
        OriginalFilename: "",
        EncryptedFilename: "",
        Date: "",
        EventID: 0,
        Event: {},
        BucketID: 0,
        Bucket: {},
        MediaType: {},
        MediaTypeID: 0,
        Author: {},
        AuthorID: 0,
        Index: 0,
      },
      playerOption: {
        index: 1,
        title: "",
        autoplay: false,
        muted: false,
        inactivityTimeout: 2000,
        fluid: true,
        sources: [
          {
            type: "",
            src: "",
          },
        ],
        html5: {
          hls: {
            overrideNative: true,
          },
          nativeAudioTracks: false,
          nativeVideoTracks: false,
        },
        playbackRates: [1, 1.25, 1.5, 1.75, 2],
        ready: false,
      },
      activeCardHandoutList: [],
      EventList: [],
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    changeDirection() {
      this.showActiveCard = false;
      this.direction = this.direction.reverse();
      this.EventList = this.EventList.reverse();
    },
    initialize() {
      this.showList = true;
      this.EventList = [];
      this.activeCardHandoutList = [];
      this.showActiveCard = false;
      this.activeCard.ready = false;
      axios
        .get("/api/content/category/" + this.id)
        .then((response) => {
          this.categoryData = response.data;
          if (this.categoryData.ThumbnailURL != "") {
            this.showThumbnail = true;
          }
        })
        .catch(() => {});
      axios
        .get("/api/content/category/" + this.id + "/eventlist")
        .then((response) => {
          this.EventList = response.data;
          this.EventList.map((x) => {
            let eventDate = new Date(x.Date);
            x.Date =
              eventDate.getDate() +
              " " +
              this.months[eventDate.getMonth()] +
              " " +
              eventDate.getFullYear();
            if (eventDate.getFullYear() == 1) {
              x.Date = "";
            }
          });
          this.activeCard.ready = false;
          if (this.EventList.length == 1) {
            this.showList = false;
            this.loadEvent(this.EventList[0].ID);
          }
          if (this.customBehaviour == "latest") {
            this.changeDirection();
          }
          if (!isNaN(this.customBehaviour) && this.customBehaviour > 0) {
            this.loadEvent(parseInt(this.customBehaviour));
          }
        })
        .catch(() => {});
    },
    loadEvent(eventID) {
      axios
        .get("/api/content/event/" + eventID + "/mediaentrylist")
        .then((response) => {
          let activeCardMediaList = response.data;
          // 1 = audio
          let activeCardList = activeCardMediaList.filter(
            (x) => x.MediaTypeID == 1
          );
          if (activeCardList.length >= 1) {
            this.activeCard = activeCardList[0];
            this.activeCard.ready = true;
          } else {
            this.activeCard.ready = false;
          }
          this.activeCardVideoList = activeCardMediaList.filter(
            (x) => x.MediaTypeID == 2
          );
          if (this.activeCardVideoList.length > 0) {
            this.activeCardVideo = this.activeCardVideoList[0];
            this.playerOption.title = this.activeCardVideo.Event.Name;
            this.playerOption.sources = [
              {
                src:
                  this.activeCardVideo.Url +
                  "?" +
                  Math.round(Math.random() * 1000),
              },
            ];
            if (
              this.activeCardVideo.ThumbnailUrl &&
              this.activeCardVideo.ThumbnailUrl.length > 0
            ) {
              this.playerOption.poster = this.activeCardVideo.ThumbnailUrl;
            } else {
              this.playerOption.poster = "";
            }
            this.activeCardVideo.ready = true;
          } else {
            this.activeCardVideo.ready = false;
          }
          this.activeCardPhotoList = activeCardMediaList.filter(
            (x) => x.MediaTypeID == 3
          );
          if (this.activeCardPhotoList.length > 0) {
            this.activeCardPhoto = this.activeCardPhotoList[0];
            this.activeCardPhoto.ready = true;
          } else {
            this.activeCardPhoto.ready = false;
          }
          this.activeCardHandoutList = activeCardMediaList.filter(
            (x) => x.MediaTypeID == 4
          );
          this.eventData = this.EventList.filter((x) => x.ID == eventID)[0];
          this.showActiveCard = true;
        })
        .catch(() => {});
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    downloadFile(downloadurl, ID) {
      let trackURL = "/api/content/mediaentry/" + ID + "/trackdownload";
      axios({
        url: downloadurl,
        headers: {
          "Cache-Control": "no-cache",
          Authorization: "",
        },
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        axios.get(trackURL);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        let filename = downloadurl.substring(
          downloadurl.lastIndexOf("/") + 1,
          downloadurl.length
        );
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
  },
};
if (document.addEventListener) {
  document.addEventListener(
    "contextmenu",
    function (e) {
      e.preventDefault();
    },
    false
  );
} else {
  document.attachEvent("oncontextmenu", function () {
    window.event.returnValue = false;
  });
}
</script>

<style>
.v-card__text,
.v-card__title {
  word-break: normal;
}
.carousel {
  background-color: #d3d3d3;
}
</style>